/**
 * 小程序配置文件
 */

// 此处主机域名是腾讯云解决方案分配的域名
// 小程序后台服务解决方案：https://www.qcloud.com/solution/la

// var host = "14592619.qcloud.la";

/* 线上配置 */
var apiHost = 'https://app.rongketech.com'
/* 本地配置 */
// var apiHost = 'http://127.0.0.1:8030'
// 测试
// var apiHost = 'https://app.rongketech.com'
// 总统
// var apiHost = 'http://192.168.210.192:8030'/
// 路哥
// var apiHost = "http://192.168.210.237:8030"
// 杰哥
// var apiHost = 'http://192.168.210.238:8030'

let env = process.env.NODE_ENV || ''
// 一级域名 rongketech.com或者htangcloud.com
let topDomainName = "rongketech.com";
if(window.location.host.indexOf("htangcloud.com") >= 0) {
  topDomainName = "htangcloud.com";
}
console.log('env------------------', env, window.location.host, topDomainName);

var config = {
  // 下面的地址配合云端 Server 工作
  // host,
  apiHost,
  // 一级域名
  topDomainName: topDomainName,
  //短信验证码
  sendLoginSMS: `${apiHost}/bpo-web/uc/user/sendLoginSMS`,
  //登录
  appLoginSMS: `${apiHost}/bpo-web/uc/user/appLoginSMS`,
  //银行卡照片
  bankcard: `${apiHost}/bpo-web/upload/bankcard`,
  //银行卡发送验证码
  bindCardSendSms: `${apiHost}/bpo-web/uc/userAccount/bindCardSendSms`,
  //保留个人信息
  saveAuthInfo: `${apiHost}/bpo-web/uc/userAccount/saveAuthInfo`,
  //我的信息
  signInfo: `${apiHost}/bpo-web/query/userSign/signInfo`,
  //同意协议
  frame: `${apiHost}/bpo-web/uc/userSign/sign/frame`,
  //用户登录历史信息
  loginRecord: `${apiHost}/bpo-web/uc/user/loginRecord`,
  // 上传身份证正面
  idCardOcr: `${apiHost}/bpo-web/upload/idCardOcr`,
  // 上传身份证背面
  uploadOss: `${apiHost}/bpo-web/upload/uploadOss`,
  // 实名认证保存基本信息(点击仅实名)
  basicAuthInfo: `${apiHost}/bpo-web/uc/h5Account/basicAuthInfo`,
  // 实名认证保存卡信息(点击仅实名)
  cardAuthInfo: `${apiHost}/bpo-web/uc/h5Account/cardAuthInfo`,
  // 开通电子账户保留个人信息（点击继续开通）
  accBasicAuthInfo: `${apiHost}/bpo-web/uc/h5Account/accBasicAuthInfo`,
  // 开通电子账户发送短信（点击继续开通）
  sendSms: `${apiHost}/bpo-web/uc/h5Account/sendSms`,
  // 开通电子账户（点击继续开通）
  openAccount: `${apiHost}/bpo-web/uc/h5Account/openAccount`,
  // 获取民族列表
  getNation: `${apiHost}/bpo-web/uc/h5Account/getNation`,
  // 用户H5资料校验
  userH5Check: `${apiHost}/bpo-web/uc/h5Account/userH5Check`,
  // 我的钱包
  myWallet: `${apiHost}/bpo-web/uc/h5Account/myWallet`,
  // H5用户首页信息
  h5UserHomeInfo: `${apiHost}/bpo-web/uc/userH5/homeInfo`,
  // 余额签约发送短信
  balanceSignSendSms: `${apiHost}/bpo-web/uc/h5Account/balanceSignSendSms`,
  // 余额签约
  balanceSign: `${apiHost}/bpo-web/uc/h5Account/balanceSign`,
  // 转账发送验证码
  transferSendSms: `${apiHost}/bpo-web/uc/h5Account/transferSendSms`,
  // 提现
  transferConfirm: `${apiHost}/bpo-web/uc/h5Account/transferConfirm`,
  // 二类户流水
  accountRecord: `${apiHost}/bpo-web/uc/h5Account/accountRecord`,
  // 二类户绑定银行卡发送短信
  bindCardSendSmsd: `${apiHost}/bpo-web/uc/h5Account/bindCardSendSms`,
  // 二类户绑定银行卡
  bindCard: `${apiHost}/bpo-web/uc/h5Account/bindCard`,
  // 获取任务详情
  platformDetail: `${apiHost}/bpo-web/platform/task/platformDetail`,
  // 申请接单
  applyH5: `${apiHost}/bpo-web/uc/h5Account/applyH5`,
  // 1.H5实名认证资料校验
  authInfo: `${apiHost}/bpo-web/uc/userH5/authInfo`,
  // 2.H5开通二类户资料校验
  checkOpenAccount: `${apiHost}/bpo-web/uc/h5Account/openAccount`,
  // // 3.H5我的钱包资料校验
  checkMyWallet: `${apiHost}/bpo-web/uc/userH5/myWallet`,
  // // 4.H5任务详情资料校验
  taskDetail: `${apiHost}/bpo-web/uc/userH5/taskDetail`,
  // // 5.H5首页信息
  indexInfo: `${apiHost}/bpo-web/uc/userH5/indexInfo`,
  // 我的签约
  mySign: `${apiHost}/bpo-web/uc/h5Account/mySign`,
  sendLoginSms: `${apiHost}/bpo-web/uc/userH5/sendLoginSms`,
  h5Login: `${apiHost}/bpo-web/uc/userH5/h5Login`,
  h5AutoLogin: `${apiHost}/bpo-web/uc/userH5/h5AutoLogin`,
  scanOrder: `${apiHost}/bpo-web/uc/userH5/scanOrder`,
  // 个人中心统计数据
  userStatInfo: `${apiHost}/bpo-web/uc/h5Account/userStatInfo`,
  // H5扫码首页跳转
  scanOrderJump: `${apiHost}/bpo-web/uc/userH5/scanOrderJump`,
  // 我的申请
  platformTaskApply: `${apiHost}/bpo-web/uc/h5Account/platformTaskApply`,
  // 撤销申请
  cancelApplication: `${apiHost}/bpo-web/uc/h5Account/cancelApplication`,
  // 我的工单列表
  myWorkloads: `${apiHost}/bpo-web/uc/h5Account/myWorkloads`,
  // 工单详情
  workloadInfo: `${apiHost}/bpo-web/uc/h5Account/workloadInfo`,
  // 我的结算列表
  tradeOrderItemPage: `${apiHost}/bpo-web/uc/h5Account/tradeOrderItemPage`,
  // 结算详情
  tradeOrderItemDetail: `${apiHost}/bpo-web/uc/h5Account/tradeOrderItemDetail`,
  // 三方跳转
  thirdRedirectUrl: `${apiHost}/bpo-web/uc/h5Account/thirdRedirectUrl`,

  // --------定制化签约----------
  // 结算详情
  companyMemberSignParamValid: `${apiHost}/bpo-web/company/member/sign/paramsValid`,
  // 结算详情
  companyMemberHandSign: `${apiHost}/bpo-web/company/member/sign/contractHandSign`,

  // 加载自定义协议
  agreementQuery: `${apiHost}/bpo-web/platform/task/agreement/query`,
  // 同意自定义协议
  agreementAgree: `${apiHost}/bpo-web/platform/task/agreement/agree`,

}

module.exports = config



// WEBPACK FOOTER //
// ./src/utils/config.js